import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { BASE_FUN_URL, BASE_URL, timeZones } from "../constant";
import AppContext from "../AppContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./Loader";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useTranslation } from "react-i18next";

function Button({ label, iconSrc, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex-col w-64 h-32 border-2 dark:hover:border-blue-700 hover:border-blue-500 dark:text-white text-labels dark:border-zinc-800 border-zinc-300 rounded-lg flex justify-center items-center dark:bg-zinc-900 bg-settingsCardS hover:text-white hover:bg-gradient-to-b dark:from-blue-700 from-blue-500 to-zinc-400 dark:to-zinc-900 gap-3"
    >
      <img
        src={iconSrc}
        alt={label}
        className="h-12 dark:text-white text-white"
      />
      {label}
    </button>
  );
}

const Settings = () => {
  const { t } = useTranslation();
  // const timezones = [
  //   "Europe/London",
  //   "Asia/Tokyo",
  //   "Asia/Calcutta",
  //   "Asia/Dubai",
  //   // Add more timezones as needed
  // ];
  const defaultSettings = [
    {
      id: 1,
      label: t(`settings.assetTemplate`),
      iconSrc: "AssetType_Icon.svg",
      route: "/assettype",
      enabledRoles: [100],
      visible: true,
    },
    {
      id: 2,
      label: t(`settings.deviceTemplate`),
      iconSrc: "configureImage.svg",
      route: "/controllerlist",
      enabledRoles: [100],
      visible: true,
    },
    {
      id: 3,
      label: t(`settings.userMaster`),
      iconSrc: "userImage.svg",
      route: "/userlist",
      enabledRoles: [100, 200],
      visible: true,
    },
    {
      id: 4,
      label: t(`settings.companyMaster`),
      iconSrc: "companyImage.svg",
      route: "/companyList",
      enabledRoles: [100],
      visible: true,
    },
    {
      id: 5,
      label: t(`settings.teamMaster`),
      iconSrc: "team-icon.svg",
      route: "/teamList",
      enabledRoles: [100, 200],
      visible: true,
    },
    {
      id: 6,
      label: t(`settings.fuelMaster`),
      iconSrc: "fuel-pump.svg",
      route: "/fuellist",
      enabledRoles: [100, 200],
      visible: false,
    },
    {
      id: 7,
      label: t(`settings.assetScheduler`),
      iconSrc: "calendar.svg",
      route: "/assetSchedulerList",
      enabledRoles: [100, 200],
      visible: false,
    },
  ];
  const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const { authCtx, config, setConfig } = useContext(AppContext);
  const [settings, setSettings] = useState(defaultSettings);
  const [assetTypes, setAssetTypes] = useState();
  const [deviceData, setDeviceData] = useState();
  const [assetLoader, setAssetLoader] = useState(false);
  const [deviceLoader, setDeviceLoader] = useState(false);
  const [publishLoader, setPublishLoader] = useState(false);
  const [timeZoneForm, setTimeZoneForm] = useState(false);
  const [timeZoneLoader, setTimeZoneLoader] = useState(false);

  const navigate = useNavigate();

  const loadAsset = async (enabledAssetTypes) => {
    setAssetLoader(true);
    const res = await axios.get(`${BASE_URL}/AssetType/GetAllAssetTypes`);
    if (res.status === 200) {
      setAssetLoader(false);
      setAssetTypes(res.data.filter((x) => enabledAssetTypes.includes(x.id)));
    }
  };

  const loadSettings = async () => {
    const companyId = authCtx.profile?.companyId;
    if (companyId !== null) {
      const res = await axios.get(`${BASE_URL}/api/CompanyMaster/${companyId}`);
      if (res.status === 200) {
        setSettings((pre) =>
          settings.map((x) =>
            x.id === 6
              ? { ...x, visible: res.data.isFuelActive }
              : x.id === 7
              ? { ...x, visible: res.data.isSchedulerActive }
              : x
          )
        );
        const enabledAssetTypes = res.data.enabledAssetTypes || [];
        loadAsset(enabledAssetTypes);
      }
    } else {
      if (authCtx.profile.role === 100)
        setSettings((pre) => settings.map((x) => ({ ...x, visible: true })));
    }
  };

  const loadDevice = async () => {
    setDeviceLoader(true);
    const res = await axios.get(`${BASE_URL}/DeviceType/GetAllDeviceTypes`);
    if (res.status === 200) {
      setDeviceLoader(false);
      setDeviceData(res.data);
    }
  };

  const onPublish = async () => {
    setPublishLoader(true);
    try {
      const res = await axios.post(`${BASE_FUN_URL}/api/resetCache`);
      setPublishLoader(false);
      if (res.status === 200) {
        toast.success("Cache reset successfully!");
      } else {
        toast.error("Failed to reset cache");
      }
    } catch (error) {
      setPublishLoader(false);
      toast.error("An error occurred while resetting cache");
    }
  };

  const onTimeZoneSave = async () => {
    setTimeZoneLoader(true);
    try {
      const updatedConfig = config;
      const res = await axios.post(
        `${BASE_URL}/api/UserConfiguration`,
        updatedConfig
      );
      if (res.status === 200) {
        setConfig((pre) => ({ ...pre, timeZone: res.data.timeZone }));
      } else toast.error("An error occured");
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
      else toast.error("An error occured");
    }
    setTimeZoneLoader(false);
    setTimeZoneForm(false);
  };

  // useEffect(() => {
  //   if (superAdminCompany)
  //     setSettings((pre) =>
  //       settings.map((x) =>
  //         x.id === 5
  //           ? { ...x, visible: superAdminCompany.isFuelActive }
  //           : x.id === 6
  //           ? { ...x, visible: superAdminCompany.isSchedulerActive }
  //           : x
  //       )
  //     );
  // }, []);

  useEffect(() => {
    loadSettings();
    loadDevice();
  }, []);

  return (
    <div className="flex w-full justify-end bg-lightModeBg dark:bg-darkModeBg">
      <div className="text-white flex flex-col gap-3 items-start w-2/3 h-full">
        {/* <div className="flex flex-col text-white font-semibold text-base gap-4 w-fit justify-center h-full"> */}
        <div className="flex gap-5 justify-between w-full pr-[10%] pt-10">
          <div className="grid grid-cols-2 gap-4 h-full flex-shrink-0">
            {settings.map(
              (ds, index) =>
                ds.enabledRoles.includes(authCtx.profile?.role) &&
                ds.visible && (
                  <Button
                    key={index}
                    label={ds.label}
                    iconSrc={ds.iconSrc}
                    onClick={() => navigate(ds.route)}
                  />
                )
            )}
          </div>
          <div className="flex flex-col justify-start gap-5 items-start h-full">
            <button
              type="button"
              onClick={onPublish}
              className="disabled:opacity-40"
              disabled={publishLoader}
            >
              <div className="flex py-2 w-auto lg:px-16 md:px-8 px-4 h-fit border-2 hover:border-blue-700 dark:border-zinc-800 border-zinc-500 rounded-lg justify-center items-center dark:bg-zinc-900 bg-resetCacheBtn hover:text-white hover:bg-gradient-to-b from-blue-700 to-zinc-900 gap-3">
                <img
                  src="publish.svg"
                  alt="AssetMasterIcon"
                  className="h-5 text-white "
                />
                {t(`button.resetCache`)}
              </div>
            </button>
            <div
              className={`dark:bg-black bg-timezoneCard border-2 dark:border-zinc-800 border-zinc-500 rounded-lg w-full flex flex-col p-5 space-y-5 ${
                !timeZoneForm ? "px-5 py-3" : "p-5"
              }`}
            >
              <div className="flex justify-between">
                <label className="text-sm text-neutral-300 font-medium">
                  {t(`settings.timeZoneText`)}
                </label>
              </div>
              {timeZoneForm ? (
                <div className="space-y-5 transition-all ease-in-out duration-500">
                  <div className="space-y-1">
                    <label className="text-white text-xs font-medium">
                      {t(`settings.timeZoneText`)}
                    </label>
                    <div className=" w-full h-8">
                      <ComboBox
                        data={timeZones}
                        name="type"
                        textField="name"
                        suggest={true}
                        clearButton={false}
                        style={{ fontSize: "10px", fontWeight: "500" }}
                        size={"small"}
                        className=" block placeholder:text-white border-grey-light text-white rounded w-full h-full"
                        onChange={(e) =>
                          setConfig((pre) => {
                            if (pre !== null)
                              return { ...pre, timeZone: e.target.value.zone };
                            else
                              return {
                                userId: authCtx.profile.id,
                                timeZone: e.target.value.zone,
                              };
                          })
                        }
                        value={
                          config?.timeZone
                            ? timeZones.find((x) => x.zone === config?.timeZone)
                            : timeZones.find((x) => x.zone === currentTimeZone)
                        }
                      />
                    </div>
                  </div>
                  <div className="flex gap-2 text-sm font-medium">
                    <button
                      type="button"
                      onClick={() => setTimeZoneForm(false)}
                      className="disabled:opacity-40 bg-gray-700 py-1 w-full rounded"
                      // disabled={timeZoneLoader}
                    >
                      {t(`button.cancel`)}
                    </button>
                    <button
                      type="button"
                      onClick={() => onTimeZoneSave()}
                      className="disabled:opacity-40 bg-blue-700 py-1 w-full rounded"
                      disabled={timeZoneLoader}
                    >
                      {t(`button.save`)}
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex justify-between text-xs font-medium">
                  <label>
                    {config?.timeZone
                      ? timeZones.find((x) => x.zone === config?.timeZone)?.name
                      : timeZones.find((x) => x.zone === currentTimeZone)?.name}
                  </label>
                  <button type="button" onClick={() => setTimeZoneForm(true)}>
                    <img
                      src="Popupedit-button.svg"
                      alt="popupEdit"
                      className="h-4"
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="w-[530px] flex flex-col gap-3">
          <div className=" leading-loose dark:bg-zinc-800 bg-settingsTitleBar text-white rounded-md py-3 mt-5">
            <label className="px-3"> {t(`settings.assetMasters`)}</label>
          </div>
          {assetLoader && <Loader />}
          <div className=" grid grid-cols-2 gap-4 ">
            {assetTypes?.map((i) => (
              <Button
                key={i.id}
                label={i.name}
                iconSrc="Asset_Template_icon.svg"
                onClick={() =>
                  navigate(`/assettypepropertylist/${i.name}/${i.id}`)
                }
              />
            ))}
          </div>
          <div className="leading-loose dark:bg-zinc-800 bg-settingsTitleBar text-white rounded-md py-3 mt-5">
            <label className="px-3">{t(`settings.deviceMasters`)}</label>
          </div>
          {deviceLoader && <Loader />}
          <div className="grid grid-cols-2 gap-4 pb-10">
            {deviceData?.map((i) => (
              <Button
                key={i.id}
                label={i.label}
                iconSrc="Device_Template_icon.svg"
                onClick={() =>
                  navigate(`/devicepropertylist/${i.label}/${i.id}`)
                }
              />
            ))}
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <ToastContainer />
      </div>
    </div>
  );
};

export default Settings;
